module.exports = __webpack_public_path__ + "static/media/MIMPYlogo.14332662.svg";